import React from 'react';
import styled from 'styled-components';
import useEventBookingSession from 'features/Events/hooks/useEventBookingSession';
import { SkeletonLine } from 'components/theme/Skeleton/Skeleton';

const maxHeadlineLength = 90;

const EventHeadline = () => {
  const { isLoading, listing } = useEventBookingSession();

  if (isLoading || !listing) {
    return <HeadlineSkeleton />;
  }

  let { summary } = listing;
  if (summary && summary.length > maxHeadlineLength) {
    summary = `${summary.slice(0, maxHeadlineLength)}...`;
  }

  return <Headline className="event_details_headline">{summary}</Headline>;
};

const Headline = styled.h3`
  margin: 0px;
  font-size: 32px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const HeadlineSkeleton = styled(SkeletonLine)`
  height: 37px;
  margin-bottom: 21px;
`;

export default EventHeadline;
